/* eslint-disable */
import { styled } from '@mui/system';
import ModalUnstyled from '@mui/base/ModalUnstyled';

import { CSSProperties } from '@mui/styles';
import backgroundImage from '../assets/icons/bg.svg';
/**
 * Fonts for Auth component
 */
export const h2Style = {
  fontFamily: 'SFProDisplay-Medium',
  fontWeight: 'inherit',
  fontStyle: 'normal',
  fontSize: '24px',
  lineHeight: '30px',
  color: 'rgba(0, 33, 69, 0.85)',
};

export const backgroundStyle: CSSProperties = {
  height: '100%',
  minHeight: '100vh',
  margin: '0',
  display: 'flex',
  backgroundImage: `url(${backgroundImage})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  width: '100%',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: 'rgb(0, 90, 210)',
};

export const pStyle = {
  fontFamily: 'SFProDisplay-Medium',
  fontSize: '16px',
  fontWeight: '400',
  color: '#5C5D68',
  marginBottom: '11px',
  lineHeight: '20px',
};

export const pSubtitle = {
  fontFamily: 'SFProDisplay-Medium',
  fontSize: '15px',
  fontWeight: '500',
  color: 'rgba(0, 33, 69, 0.85)',
  marginBottom: '11px',
};

export const h2BoldStyle = {
  ...h2Style,
  fontWeight: '700',
};
export const h2SemiBoldStyle = {
  ...h2Style,
  fontSize: '16px',
  fontWeight: '600',
};

export const pLabelStyle: CSSProperties = {
  ...pStyle,
  fontSize: '15px',
  textDecoration: 'none',
  lineHeight: '20px',
  fontWeight: '500' as any,
  color: '#227BEF',
};

export const pLabelDarkerStyle = {
  ...pLabelStyle,
  color: '#333333',
};
//////////////////////
export const paperStyle = {
  padding: '80px 80px 24px 80px',
  borderRadius: '32px',
  border: '1px solid #F0F0F0',
};

export const btnStyle: CSSProperties = {
  margin: '0px 0',
  backgroundColor: 'rgba(93, 201, 246, 0.6)',
  height: '48px',
  width: '100%',
  borderRadius: '100px',
  color: '#ffffff',
  textTransform: 'none',
};

export const btnStyleActive = {
  ...btnStyle,
  backgroundColor: '#5DC9F6',
  color: '#ffffff',
};

export const TypographyStyle = {
  marginTop: '35px',
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
};

export const inputStyle = {
  marginTop: '12px',
  height: '44px',
  borderRadius: '50px',
};

export const checkBoxStyle = {
  padding: '0',
};

export const labelStyle: CSSProperties = {
  display: 'flex',
  marginTop: '32px',
  justifyContent: 'center',
  textAlign: 'center',
};

export const backLabelStyle = {
  display: 'flex',
  justifyContent: 'center',
};

export const logoStyle = {
  marginTop: '0px',
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'center',
  marginBottom: '40px',
};

export const checkListStyle = {
  marginTop: '20px',
  marginBottom: '20px',
};

export const headerStyle = { display: 'flex', justifyContent: 'space-between' };

export const avatarStyle = { marginLeft: '15px' };

export const StyledModal = styled(ModalUnstyled)`
  position: fixed;
  z-index: 1300;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Backdrop = styled('div')`
  z-index: -1;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-tap-highlight-color: transparent;
`;

export const style = {
  bgcolor: 'background.paper',
  p: 2,
  px: 4,
  pb: 3,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'white',
  borderRadius: '20px',
  width: '193px',
  height: '212px',
};

export const forgotHeaderStyle = {
  ...logoStyle,
  textAlign: 'center' as any,
  display: 'block' as any,
};
